import { Service, configBaseURL } from "../Axios/Service";
import qs from "qs";
import store from "../../store";

const PROFILE = {
  pay: "VUE_APP_PAY_PREFIX",
};

function getType(apiType) {
  return process.env[PROFILE[apiType]];
}

class PayApi {
  constructor(ApiType) {
    this.ApiType = ApiType;
  }
  //转出管理数据
  transferList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/transferList`,
      method: "post",
      data
    });
  }

  planPlanLock(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/balance/platPlanLock`,
      data: qs.stringify({'planId': data}),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  multipleRefunds(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/retrieve/multipleRefunds`,
      method: "post",
      data
    });
  }
  retrieveInfo(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/retrieve/retrieveInfo`,
      method: "post",
      data
    });
  }
  //查询累计订单金额
  balanceTotal() {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/balance/balanceTotal`,
      method: "post",
    });
  }
  //搜索总计金额
  balanceTotalBySearch(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/balance/balanceTotalBySearch `,
      method: "post",
      data: data,
    });
  }

  // 收款订单
  addCollection(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/save`,
      method: "post",
      data: data,
    });
  }
  //全部的收款订单
  allCollectionList(obj) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/collection/collectionList`,
      method: "post",
      data: obj,
    });
  }
  // 收款订单
  update(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/update`,
      method: "post",
      data: data,
    });
  }

  // 收款订单
  addCollectionDetail(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/webSaveDetail`,
      method: "post",
      data: data,
    });
  }

   // 收款订单
   deleteData(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/deleteData`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  // 收款订单
  querySearchAsync(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/querySearchAsync`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
   // 收款订单
   deleteDetailData(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/deleteDetailData`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  //收款订单退款
  collectionRefund(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/refund`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  changeColletionPlanId(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/changeColletionPlanId`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  selectBlanceData(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/selectBlanceData`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

  // 收款订单列表
  refundData(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/refundData`,
      method: "post",
      data: data,
    });
  }

  // 收款订单列表
  planCollectionTotal(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/planCollectionTotal`,
      method: "post",
      data: data,
    });
  }

  // 收款订单列表
  collectionList(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/collection/list`,
      method: "post",
      data: data,
    });
  }

    //获取加密串
    getCiphertext(data) {
      let apiType = getType(this.ApiType);
      return Service({
        url: `/${apiType}/platApi/collection/getCiphertext`,
        method: "post",
        data: qs.stringify(data),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
    }

  //余额列表
  balanceList(_data, type) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/balance/list`,
      method: "post",
      data: _data,
    });
  }

  //钱包余额
  walletTotal(_data, type) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/balance/total`,
      method: "post",
      data: _data,
    });
  }
  //钱包充值
  codePay(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/wechat/pay/codePay`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  // 钱包支付
  balanceWalletPay(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/wallet/balanceWalletPay`,
      method: "post",
      data: data,
    });
  }
  //微信支付通过这个接口判断获取支付所需要的字段
  codyPayParameter(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/wechat/pay/codyPayParameter`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //支付宝支付通过这个接口判断获取支付所需要的字段
  codyAliPayParameter(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/ali/pay/codyAliPayParameter`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //支付宝支付接口
  pcPay(data) {
    let apiType = getType(this.ApiType);
    let url = `${configBaseURL()}/${apiType}/platApi/ali/pay/pcPay?subject=${
      data.subject
    }&body=${data.body}&passbackParams=${data.passbackParams}&totalAmount=${
      data.totalAmount
    }&outTradeNo=${data.outTradeNo}`;
    return url;
  }
  //字符状态论询
  queryOrder(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/wechat/pay/queryOrder`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //订单列表的支付接口微信
  codyOrderPayParameter(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/wechat/pay/codyOrderPayParameter`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  codyAliPayOrderParameter(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/platApi/ali/pay/codyAliPayOrderParameter`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }
  //点击钱包支付时候调用的接口
  paymentApprovalQuery(data) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/wallet/paymentApprovalQuery`,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  }

}

export default PayApi;
